import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';

const AcademyFooterContainer = props => {
  const { label, text, faIcon, icon, customIcon } = props;
  return (
    <div className="academy-footer-wrapper">
      {label?.length > 0 && <div className="label">{label}</div>}
      {faIcon && <i className={faIcon} />}
      {icon && <img src={icon} alt="no-icon" />}
      {customIcon || undefined}
      <div>{text}</div>
    </div>
  );
};

AcademyFooterContainer.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  faIcon: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  customIcon: PropTypes.node,
};
AcademyFooterContainer.defaultProps = {
  faIcon: null,
  icon: null,
  customIcon: null,
  label: null,
};

export default translate(AcademyFooterContainer);
